import { getGenericEndpoint } from './get.api';
import type { BasicResponse } from './types';

export const getChangePassword = async (lang?: string) => {
	return await getGenericEndpoint<BasicResponse>('change-password', lang);
};
